import Vuex from 'vuex';
import Vue from 'vue';
import app from './modules/app';
import nav from './modules/nav';
import filter from './modules/filter';
import review from './modules/review';
import reviewSettings from './modules/review-settings';
import giftVoucherTemplates from './modules/giftVoucherTemplates';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: false,
  modules: {
    app,
    nav,
    filter,
    review,
    reviewSettings,
    giftVoucherTemplates,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js